import { ControlValueAccessor, FormControl, ValidationErrors } from '@angular/forms';
import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { AppValidationError } from './validations';
import { ValueAccessorTypes } from '@pc/common';

@Component({ template: '' })
export abstract class ValueAccessorComponent implements ControlValueAccessor {
  @Input() cid: string = Math.random().toString(36).substring(2);
  @Input() enabled = true;
  @Input() formControl?: FormControl;
  @Input() public InputError?: AppValidationError | null;

  touched = false;
  private vValue: ValueAccessorTypes = null;

  public constructor(public cdRef: ChangeDetectorRef) {}

  public get value(): ValueAccessorTypes {
    return this.vValue;
  }

  @Input()
  public set value(value: ValueAccessorTypes) {
    if (this.vValue !== value) {
      this.vValue = value;
      this.notifyValueChange();
      this.validate();
      this.cdRef.markForCheck();
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange: (value: ValueAccessorTypes) => void = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouched: (value: ValueAccessorTypes) => void = () => {};

  notifyValueChange(): void {
    if (this.onChange) {
      this.onChange(this.value);
    }
  }

  writeValue(value: ValueAccessorTypes): void {
    this.value = value;
  }

  registerOnChange(fn: never): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: never): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.enabled = !isDisabled;
  }

  markAsUntouched(validate = true): void {
    this.markTouched(false, validate);
  }

  markAsTouched(validate = true): void {
    this.markTouched(true, validate);
    this.onTouched(this.value);
  }

  protected validate(): void {
    if (this.formControl) {
      const controlErrors: ValidationErrors | null = this.formControl?.errors ?? null;
      if (controlErrors != null && Object.keys(controlErrors).length > 0) {
        this.setErrors(controlErrors);
      } else {
        this.InputError = null;
        this.markAsTouched(false);
      }
    }
  }

  private markTouched(isTouched: boolean, validate: boolean): void {
    this.touched = isTouched;
    if (this.formControl) {
      if (isTouched) {
        this.formControl.markAsTouched();
      } else {
        this.formControl.markAsUntouched();
      }
    }

    if (validate) {
      this.validate();
      this.cdRef.markForCheck();
    }
  }

  private setErrors(controlErrors: ValidationErrors): void {
    let req = false;
    let errorMessage = '';
    for (const keyError of Object.keys(controlErrors)) {
      if (keyError === 'required') {
        req = true;
        errorMessage = AppValidationError.Errors[keyError] || '';
        break;
      }
      errorMessage = AppValidationError.Errors[keyError] || '';
    }
    this.InputError = (errorMessage === '' && !req) || !this.touched ? null : new AppValidationError(errorMessage, req);
  }
}
